import fetch from "isomorphic-fetch";
import "components/Fields";
import { splited, validatedDate } from "redux/helpers";
import { filter } from "ramda";

export default class API {
  static create({
    start,
    stop,
    bannerPlaces,
    formats,
    site_id = "",
    name = ""
  }) {
    const dates = filter(Boolean, {
      start: validatedDate(start),
      stop: validatedDate(stop)
    });

    const body = Object.assign(
      {},
      bannerPlaces && { bannerPlaces: splited(bannerPlaces) },
      formats && { formats: splited(formats) }
    );

    const request = new Request(`/api/stat/${site_id}`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        ...body,
        ...dates
      })
    });

    return fetch(request);
  }
}
